import folderStore from 'owa-folders';
import updateFolderCounts from 'owa-mail-actions/lib/updateFolderCounts';
import { getFolderIdForSelectedNode } from 'owa-mail-folder-forest-store';
import { mutator } from 'satcheljs';

export default mutator(updateFolderCounts, actionMessage => {
    const folderTable = folderStore.folderTable;
    const folder = folderTable.get(actionMessage.folderId);

    if (folder) {
        if (actionMessage.isDeltaChange) {
            folder.UnreadCount += actionMessage.unreadCount;
            folder.TotalCount += actionMessage.totalCount;
        } else {
            folder.UnreadCount = actionMessage.unreadCount;
            folder.TotalCount = actionMessage.totalCount;
        }

        // If user is currently in a favorite persona folder and folder count changes, update cached
        // total count value so we don't show new message count badge.
        if (folder.pausedTotalCount && getFolderIdForSelectedNode() === actionMessage.folderId) {
            folder.pausedTotalCount = folder.TotalCount;
        }

        // Do not let counts fall below 0 in the store. This state could happen due to the timing of when
        // folder tree is loaded versus listview.
        folder.UnreadCount = Math.max(folder.UnreadCount, 0);
        folder.TotalCount = Math.max(folder.TotalCount, 0);
    }
});
